import React from 'react'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import Text from '@navent-jobs/ui-kit/components/text'
import { useTranslation } from 'react-i18next'
import { DetalleLookAndFeel, ReadMoreCustom, Container, InformationContainer } from '../../mixins'

const Component = ({ empresa, showDescription = false }) => {
  const { t } = useTranslation()
  const mostrarDescripcion = showDescription && empresa.descripcion

  return (
    <DetalleLookAndFeel>
      <InformationContainer sacarUltimoMargen={!mostrarDescripcion}>
        {empresa.industria && (
          <Container>
            <Text size="md" fontWeight="semibold" variant="gray84">
              {t('fichaAviso.sections.empresa.industria')}
            </Text>
            <Text size="md" variant="gray60">
              {empresa.industria}
            </Text>
          </Container>
        )}

        {empresa.ciudad && (
          <Container>
            <Text size="md" fontWeight="semibold" variant="gray84">
              {t('fichaAviso.sections.empresa.ubicacion')}
            </Text>
            <Text size="md" variant="gray60">
              {empresa.ciudad}, {empresa.provincia}
            </Text>
          </Container>
        )}

        {empresa.rangoEmpleados && (
          <Container>
            <Text size="md" fontWeight="semibold" variant="gray84">
              {t('fichaAviso.sections.empresa.empleados')}
            </Text>
            <Text as="span" size="md" variant="gray60">
              {`${empresa.rangoEmpleados} empleados`}
            </Text>
          </Container>
        )}
      </InformationContainer>

      {mostrarDescripcion && (
        <ReadMoreCustom
          id="descriptionCompany"
          numberOfLines={6}
          readMore={<Icon name="icon-light-arrow-ios-down" />}
          readLess={<Icon name="icon-light-arrow-ios-up" />}
          variant="primary"
          position="center"
        >
          <Text size="md" variant="gray84">
            {empresa.descripcion}
          </Text>
        </ReadMoreCustom>
      )}
    </DetalleLookAndFeel>
  )
}

export default Component
